import { render } from "./AboutService.vue?vue&type=template&id=e7244e74"
import script from "./AboutService.vue?vue&type=script&lang=js"
export * from "./AboutService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__